// Stays on the V1 account (this factory is wired to the V1 client in
// api/ltng/index.js). The V2 account is NOT provisioned for this module —
// `/v2/modules/access-requests` returns 500 "Module not active." — so the
// legal-center / service-provider-portal access flow keeps using the working V1
// account. If access-requests is later enabled on the V2 account, move this to
// the V2 client (the path is the same).
export default function (axios) {
  return {
    getAll(params = {}) {
      return axios.get('/modules/access-requests', params)
    },

    update(payload, params) {
      return axios.put('/modules/access-requests', payload, params)
    },
  }
}
